import { useState } from 'react';
import { getAllCityList } from '../apis/apis';
import { isEmpty } from '@hll/eapp-utils';

export type CityItemType = {
  cityId: number;
  latLon: {
    lat: number;
    lon: number;
  };
  name: string;
  nameEn: string;
  provinceNameCn: string;
  provinceNameEn: string;
};

type AllCityListType = { cityItem?: CityItemType[] };
// 获取ops配置的全部城市，具体到区域
export default function NewCityList() {
  const [allCityList, setAllCityList] = useState<AllCityListType>(); // 全部城市列表

  const [allCityListLoading, setAllCityListLoading] = useState(false);

  const getAllCityListConfig = async () => {
    if (allCityListLoading) {
      return;
    }
    setAllCityListLoading(true);
    const data: any = await getAllCityList();
    if (data?.ret === 0) {
      setAllCityList(data?.data);
    }
  };

  const allCityListConfigProxy = new Proxy(
    { ...allCityList },
    {
      get(obj: AllCityListType, prop: string, receiver) {
        const res = Reflect.get(obj, prop, receiver);
        if (isEmpty(res)) {
          getAllCityListConfig();
        } else {
          setAllCityListLoading(false);
        }
        return res;
      },
    }
  );
  return {
    allCityList,
    setAllCityList,
    /** 获取城市列表 loading */
    allCityListLoading,

    /** 城市数据 */
    allCityListConfigProxy,
  };
}
